var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "review-page"
  }, [_c('div', {
    staticClass: "review-page__wrapper"
  }, [_c('DataEntityList', {
    attrs: {
      "get": _vm.$api.review.getByProductID,
      "get-list": _vm.wrapFunc(function (res) {
        return res === null || res === void 0 ? void 0 : res.review;
      }),
      "watch-param-changes": "",
      "params": _vm.params,
      "get-pagination-data": _vm.wrapFunc(function (res) {
        return res === null || res === void 0 ? void 0 : res.pagination;
      })
    },
    on: {
      "success": function ($event) {
        _vm.list = $event.list;
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var loading = _ref.loading,
            error = _ref.error,
            initialLoad = _ref.initialLoad,
            pageCount = _ref.pageCount,
            pageCurrent = _ref.pageCurrent,
            loadMore = _ref.loadMore,
            changePage = _ref.changePage,
            sortList = _ref.sortList,
            activeSort = _ref.activeSort,
            sort = _ref.sort,
            itemsCount = _ref.itemsCount;
        return [loading && initialLoad ? _c('StatusBlock', {
          attrs: {
            "size": "m",
            "type": "loading"
          }
        }) : error ? _c('Note', {
          staticClass: "product-page__creation-note",
          attrs: {
            "theme": "reddish"
          }
        }, [_vm._v("\n        Что то пошло не так\n      ")]) : _c('div', [_c('h5', {
          staticClass: "review-page__title"
        }, [_vm._v("\n          Отзывы"), _c('span', {
          staticClass: "review-page__title-sup"
        }, [_vm._v(_vm._s(_vm.response.product.rate.count))])]), _vm._v(" "), _c('ReviewRating', {
          staticClass: "review-page__review-rating",
          attrs: {
            "data": _vm.response.product.rate,
            "link": "create/"
          }
        }), _vm._v(" "), _vm.list.length ? _c('div', {
          ref: "reviewWrap"
        }, [_c('div', {
          staticClass: "review-page__review-wrap review-page__review-wrap_desktop"
        }, [_c('div', {
          staticClass: "review-page__sort-wrap"
        }, [_c('Sort', {
          attrs: {
            "list": sortList,
            "value": activeSort
          },
          on: {
            "sort": function ($event) {
              sort($event), _vm.changeQuery($event.value);
            }
          }
        })], 1), _vm._v(" "), _vm._l(_vm.list, function (item, i) {
          return [_c('UIActionList', {
            key: ("" + (item.id + i)),
            attrs: {
              "actions": {
                like: _vm.$api.review.like,
                dislike: _vm.$api.review.dislike
              }
            },
            on: {
              "error": _vm.onError
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function (_ref2) {
                var like = _ref2.like,
                    dislike = _ref2.dislike;
                return [_c('Review', {
                  key: item.id,
                  staticClass: "mb-20",
                  attrs: {
                    "data": item,
                    "product-id": _vm.response.product.id,
                    "data-e2e": "product-review-block",
                    "data-review-id": item.id
                  },
                  on: {
                    "positive": function ($event) {
                      _vm.recalculateLikes({
                        send: function () {
                          return like.request($event);
                        },
                        data: item,
                        param: 'like',
                        param2: 'dislike'
                      });
                    },
                    "negative": function ($event) {
                      _vm.recalculateLikes({
                        send: function () {
                          return dislike.request($event);
                        },
                        data: item,
                        param: 'dislike',
                        param2: 'like'
                      });
                    },
                    "report": function ($event) {
                      return _vm.enableReport(_vm.response.product.id);
                    }
                  },
                  scopedSlots: _vm._u([{
                    key: "response",
                    fn: function (_ref3) {
                      var data = _ref3.data,
                          toggleShow = _ref3.toggleShow;
                      return [_c('UIActionEntity', {
                        attrs: {
                          "get": _vm.$api.review.addComment
                        },
                        on: {
                          "error": _vm.onError,
                          "success": function ($event) {
                            return _vm.onSuccessAddedComment({
                              toggleShow: toggleShow
                            });
                          }
                        },
                        scopedSlots: _vm._u([{
                          key: "default",
                          fn: function (_ref4) {
                            var get = _ref4.get;
                            return [_c('ReviewComment', {
                              attrs: {
                                "id": data.id,
                                "name": data.name,
                                "placeholder": ("Ответ пользователю " + (data.name)),
                                "product-id": _vm.response.product.id
                              },
                              on: {
                                "click": get
                              }
                            })];
                          }
                        }], null, true)
                      })];
                    }
                  }, {
                    key: "commentary",
                    fn: function (_ref5) {
                      var comments = _ref5.comments,
                          data = _ref5.data;
                      return [_vm._l(comments, function (comment) {
                        return [_c('UIActionList', {
                          key: comment.id,
                          attrs: {
                            "actions": {
                              likeComment: _vm.$api.review.likeComment,
                              dislikeComment: _vm.$api.review.dislikeComment
                            }
                          },
                          on: {
                            "error": _vm.onError
                          },
                          scopedSlots: _vm._u([{
                            key: "default",
                            fn: function (_ref6) {
                              var likeComment = _ref6.likeComment,
                                  dislikeComment = _ref6.dislikeComment;
                              return [_c('Comment', {
                                key: comment.id,
                                attrs: {
                                  "review-id": data.id,
                                  "data": comment
                                },
                                on: {
                                  "positive": function ($event) {
                                    _vm.recalculateLikes({
                                      send: function () {
                                        return likeComment.request($event);
                                      },
                                      data: comment,
                                      param: 'like',
                                      param2: 'dislike'
                                    });
                                  },
                                  "negative": function ($event) {
                                    _vm.recalculateLikes({
                                      send: function () {
                                        return dislikeComment.request($event);
                                      },
                                      data: comment,
                                      param: 'dislike',
                                      param2: 'like'
                                    });
                                  },
                                  "report": function ($event) {
                                    return _vm.enableReport(_vm.response.product.id);
                                  }
                                },
                                scopedSlots: _vm._u([{
                                  key: "default",
                                  fn: function (_ref7) {
                                    var toggleShow = _ref7.toggleShow;
                                    return [_c('UIActionEntity', {
                                      attrs: {
                                        "get": _vm.$api.review.addComment
                                      },
                                      on: {
                                        "error": _vm.onError,
                                        "success": function ($event) {
                                          return _vm.onSuccessAddedComment({
                                            toggleShow: toggleShow
                                          });
                                        }
                                      },
                                      scopedSlots: _vm._u([{
                                        key: "default",
                                        fn: function (_ref8) {
                                          var get = _ref8.get;
                                          return [_c('ReviewComment', {
                                            attrs: {
                                              "id": data.id,
                                              "name": comment.name,
                                              "placeholder": ("Ответ пользователю " + (comment.name)),
                                              "product-id": _vm.response.product.id
                                            },
                                            on: {
                                              "click": get
                                            }
                                          })];
                                        }
                                      }], null, true)
                                    })];
                                  }
                                }], null, true)
                              })];
                            }
                          }], null, true)
                        })];
                      })];
                    }
                  }], null, true)
                })];
              }
            }], null, true)
          })];
        })], 2), _vm._v(" "), _c('div', {
          staticClass: "review-page__review-wrap review-page__review-wrap_mobile"
        }, [_c('div', {
          staticClass: "review-page__sort-wrap"
        }, [_c('SortSelect', {
          attrs: {
            "list": sortList,
            "value": activeSort
          },
          on: {
            "change": sort
          }
        })], 1), _vm._v(" "), _vm._l(_vm.list, function (item, i) {
          return [_c('UIActionList', {
            key: ("" + (item.id + i)),
            attrs: {
              "actions": {
                like: _vm.$api.review.like,
                dislike: _vm.$api.review.dislike
              }
            },
            on: {
              "error": _vm.onError
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function (_ref9) {
                var like = _ref9.like,
                    dislike = _ref9.dislike;
                return [_c('ReviewMobile', {
                  key: item.id,
                  staticClass: "review-page__review",
                  attrs: {
                    "review": item,
                    "product-id": _vm.response.product.id,
                    "data-e2e": "product-review-block",
                    "data-review-id": item.id,
                    "show-field-button": false
                  },
                  on: {
                    "positive": function ($event) {
                      _vm.recalculateLikes({
                        send: function () {
                          return like.request({
                            id: item.id
                          });
                        },
                        data: item,
                        param: 'like',
                        param2: 'dislike'
                      });
                    },
                    "negative": function ($event) {
                      _vm.recalculateLikes({
                        send: function () {
                          return dislike.request({
                            id: item.id
                          });
                        },
                        data: item,
                        param: 'dislike',
                        param2: 'like'
                      });
                    },
                    "report": function ($event) {
                      return _vm.enableReport(_vm.response.product.id);
                    },
                    "click-answer": function ($event) {
                      return _vm.$router.push(((item.id) + "?activeField=true"));
                    },
                    "click": function ($event) {
                      return _vm.$router.push(item.id);
                    }
                  }
                })];
              }
            }], null, true)
          })];
        })], 2), _vm._v(" "), itemsCount > 7 && pageCurrent && pageCount ? _c('TSHybridPagination', {
          staticClass: "mt-25",
          attrs: {
            "quantity-on-page": 7,
            "pagination": {
              count: pageCount,
              current: pageCurrent,
              itemQuantity: itemsCount
            },
            "entities-list": ['отзыв', 'отзыва', 'отзывов'],
            "show-more": ""
          },
          on: {
            "change-page": function ($event) {
              changePage($event), _vm.onScrollTop();
            },
            "load-more": loadMore
          }
        }) : _vm._e()], 1) : _c('Note', {
          staticClass: "product-page__creation-note"
        }, [_vm._v("\n          К этому товару еще не оставляли отзывы\n        ")])], 1)];
      }
    }])
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }